<template>
  <div>
    <div v-if="validata == 'success'" class="contract" v-loading="loading">
      <div class="xyDiv" v-show="type == 1">
        <div class="content">
          <div class="header">
            <h1>
              서명하기
            </h1>
            <i class="el-icon-close" @click="type = 0"/>
          </div>
          <div class="title">
            <el-upload
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :on-change="showHeader"
              :show-file-list="false"
              :file-list="fileList"
              :auto-upload="false">
              <b style="display: flex;align-items: center;">
                <i class="el-icon-download" style="font-size: 18px;margin-right: 6px;"></i>서명 불러오기
              </b>
            </el-upload>

            <div style="display: flex;">
              <span style="color: #717B85;margin-right: 10px;" @click="clearFunction">지우기</span>
              <a style="font-weight: bold;" @click="saveAndUpload">저장</a>
            </div>
          </div>
          <div class="pannel">
            <canvas ref="canvas" v-show="fileNow == null"
            @mousedown="startDrawing"
            @mousemove="draw"
            @mouseup="stopDrawing"
            @mouseout="stopDrawing"
            @touchstart="startDrawing"
            @touchmove="draw"
            @touchend="stopDrawing">
            </canvas>
            <div ref="canvasImage" v-show="fileNow != null" style="display: flex;align-items: center;justify-content: center;height: 100%;">
              <img style="max-width: 100%;max-height: 100%;" :src="fileNow"/>
            </div>
          </div>
          <div class="error">
            <i class="el-icon-warning"></i>
            서명 후 저장 버튼을 눌러주세요.
          </div>
          <div class="btnConfirm btnAct" @click="saveAndUpload">
            서명하기
          </div>
        </div>
      </div>
      <div id="home" v-if="!isFull && contractInfo">
        <h1>[CREMA] 솔루션 계약서</h1>
        <div class="info">
          <div class="item" v-if="contractInfo.state != null">
            <div>
              서명 요청자
              <p>{{contractInfo.name}}(<a>{{contractInfo.phoneNumber!=null?format_phone(contractInfo.phoneNumber):'-'}}</a>)</p>
            </div>
            <span class="act">서명완료</span>
          </div>
          <div class="item" v-else>
            <div>
              서명자
              <p>{{contractInfo.name}}(<a>{{contractInfo.phoneNumber!=null?format_phone(contractInfo.phoneNumber):'-'}}</a>)</p>
            </div>
            <span>서명전</span>
          </div>
          <div class="item">
            <div>
              서명 유효기간 만료일
              <p :style="contractInfo.isExpired?'color:red;':''">{{moment(contractInfo.createAt).add(15,'days').format('YYYY년MM월DD일HH시mm분ss초')}}(UTC+09:00)</p>
            </div>
          </div>
        </div>
        <div class="pdfArea" :style="contractInfo.state == null?'padding-bottom: 72px;':'padding-bottom:20px'">
          <div class="title">
            계약서 내용
            <a @click="reset_contract_info()" v-if="contractInfo.state == null"><i class="el-icon-edit-outline"></i>수정</a>
            <a @click="fullScreen(true)"><i class="el-icon-zoom-in"></i>전체보기</a>
          </div>
          <vue-office-pdf ref="pdfCon" v-if="pdfUrl" @ready="this.loading = false" :key="pdfKey" :src="pdfUrl" style="width: 100%;height:100%;"/>
          <div style="position: fixed;width: 100vw;background-color: #ffffff;left:0;bottom:0;" v-if="contractInfo">
            <div class="btn btnAct" @click="signInit()" v-if="pdfKey == 0 && contractInfo.state == null">
              계약서에 서명하고 신청 완료하기
            </div>
            <div class="btn btnAct" @click="saveSignInfo()" v-if="pdfKey != 0 && contractInfo.state == null">
              전송
            </div>
          </div>
        </div>
      </div>
      <div v-if="isFull && contractInfo" style="background-color: #EAEFF5;">
        <div style="color: #333333;background-color: #ffffff;display: flex;align-items: center;justify-content: space-between;height: 60px;margin-bottom: 10px;padding:0 20px;">
          <span @click="fullScreen(false)">취소</span>
          <span @click="signInit()" v-if="contractInfo.state == null && pdfKey == 0">다음</span>
          <span @click="saveSignInfo()" v-if="contractInfo.state == null && pdfKey != 0">전송</span>
        </div>
        <vue-office-pdf v-if="pdfUrl" :key="pdfKey" :src="pdfUrl" style="width: 100%;height:calc(100vh - 70px);"/>
      </div>
    </div>
    <div v-if="validata == 'validata'" class="validata">
      <div id="home">
        <h1>안전한 계약을 위해 카카오 계정에 <br/>등록된 휴대폰 번호를 입력해 주세요</h1>
        <p>휴대폰 번호</p>
        <el-input
          :class="errInput !== ''?'errInput':''"
          style="width: 100%;margin-top: 10px;"
          v-model="phone"
          :editable="false"
          :clearable="false"
          @input="phoneInput"
          maxlength="13"
          type="tel">
        </el-input>
        <div class="error" v-if="errInput !== ''">
          <i class="el-icon-warning"></i>
          {{errInput}}
        </div>
        <div class="btn" :class="{btnAct:validatePhone}" @click="phoneValidate">
          확인하고 서명 진행하기
        </div>
      </div>
    </div>
    <div v-if="validata == 'inputFrom'" class="validata" :style="'height:'+innerHeight+'px;'">
      <div id="home">
        <h1>계약서 작성하기</h1>
        <p style="margin-bottom: 10px;">서명자: {{contractInfo.name}}</p>
        <p style="margin-bottom: 10px;">전화번호: {{contractInfo.phoneNumber}}</p>
        <p style="margin-bottom: 10px;">서명자 주민등록번호:</p>
        <el-input
          style="width: 100%;margin-bottom: 10px;"
          v-model="residentNumber"
          :editable="false"
          :clearable="false"
          @input="residentNumberInput"
          @blur="blurInput"
          @focus="focusInput"
          maxlength="14"
          placeholder="xxxxxx-xxxxxxx"
          type="tel">
          <img slot="append" src="../assets/imgs/show.png" style="width: 25px;margin-top:5px;" v-if="show_status" @click="switch_show_status"/>
          <img slot="append" src="../assets/imgs/no_show.png" style="width: 25px;margin-top:5px;" v-if="!show_status"  @click="switch_show_status"/>
        </el-input>
        <!-- <p style="margin-bottom: 10px;">서명자 주소:</p>
        <el-input
          type="textarea"
          :rows="4"
          style="resize: none;margin-bottom: 10px;"
          placeholder="ex.서울특별시 강남구 테헤란로 123번지"
          v-model="address">
        </el-input> -->
        <p style="margin-bottom: 10px;">임금 체불 사업자 상호명:</p>
        <el-input
          type="textarea"
          :rows="2"
          style="resize: none;"
          placeholder="임금 체불 사업자 상호명"
          v-model="companyName">
        </el-input>

        <div class="btn btnAct" @click="saveContractInfo">
          작성하기
        </div>
        <div :style="isKeyboardActive?'height:' + keyboardHeight + 'px':''"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { downFile, getAction, postAction, putAction } from '@/network/manage';
  import VueOfficePdf from '@vue-office/pdf'
  import html2canvas from 'html2canvas'
  export default {
    name: 'Contract',
    components: {
      VueOfficePdf
    },
    data() {
      return {
        validata: "validata",
        phone:'',
        errInput:'',
        loading:false,
        fileNow:null,
        fileList: [],
        isFull:false,
        contractInfo:{},
        pdfUrl:null,
        isDrawing: false,
        context: null,
        signAt:'',
        signingImage:'',
        signingDocument:'',
        pdfKey:0,
        lastX: 0,
        lastY: 0,
        uuid:'',
        type: 0,
        innerHeight:0,
        residentNumber: '',
        residentNumber_value: '',
        address: "",
        companyName: "",
        isDraw: false,

        originalHeight: window.innerHeight,
        isKeyboardActive: false,
        keyboardHeight: 0,
        show_status: false,
      }
    },
    computed: {
      validatePhone() {
        return /^01[016789]-\d{4}-\d{4}$/.test(this.phone)
      }
    },
    mounted() {
      this.innerHeight = window.innerHeight
      this.uuid = this.$route.params.uuid
      window.addEventListener('resize', this.checkKeyboardStatus);

    },
    beforeDestroy() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      window.removeEventListener('resize', this.checkKeyboardStatus);

    },
    methods:{
      blurInput() {
        let value = this.residentNumber;
        const digits = value.replace(/\D/g, '');
        const limited = digits.slice(0, 13);
        if(this.show_status) {
            if (limited.length > 6) {
                this.residentNumber =  `${limited.slice(0, 6)}-${limited.slice(6)}`;
                this.residentNumber_value = `${limited.slice(0, 6)}-${limited.slice(6)}`;
            } else {
                this.residentNumber = limited;
                this.residentNumber_value = limited;
            }
        } else {
          if(limited.length > 7) {
            this.residentNumber =  `${limited.slice(0, 6)}-${limited.slice(6, 7)}`;
            for(let i = 0;i < (limited.length - 7);i++) {
              this.residentNumber = this.residentNumber + "*";
            }
            this.residentNumber_value = `${limited.slice(0, 6)}-${limited.slice(6, limited.length)}`;
          } else if (limited.length > 6) {
            this.residentNumber =  `${limited.slice(0, 6)}-${limited.slice(6, 7)}`;
            this.residentNumber_value = `${limited.slice(0, 6)}-${limited.slice(6, 7)}`;
          } else {
              this.residentNumber = limited;
              this.residentNumber_value = limited;
          }
        }
      },
      focusInput() {
        this.residentNumber = this.residentNumber_value
      },
      switch_show_status() {
        this.show_status = !this.show_status
        this.focusInput();
        this.blurInput();
      },
      checkKeyboardStatus() {
        const newHeight = window.innerHeight;
        const heightDiff = this.originalHeight - newHeight;

        if (Math.abs(heightDiff) > 100) {
          this.isKeyboardActive = true;
          this.keyboardHeight = Math.abs(heightDiff);
        } else {
          this.isKeyboardActive = false;
          this.keyboardHeight = 0;
        }
      },
      async saveContractInfo() {
        if(this.residentNumber_value == "") {
          this.$message({showClose: true,message: '서명자 주민등록번호를 입력하십시오.',type: 'warning'});
          return;
        }
        if(this.residentNumber_value.length != 14) {
          this.$message({showClose: true,message: '올바른 서명자 주민등록번호를 입력하십시오.',type: 'warning'});
          return;
        }
        // if(this.address == "") {
        //   this.$message({showClose: true,message: '서명자 주소를 입력하십시오.',type: 'warning'});
        //   return;
        // }
        if(this.companyName == "") {
          this.$message({showClose: true,message: '임금 체불 기업의 상호를 입력하십시오.',type: 'warning'});
          return;
        }
        let that = this
        this.$confirm('계약서를 작성하시겠습니까?', '힌트', {
          confirmButtonText: '작성하기',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(async () => {
          let param = {companyName: that.companyName, residentNumber: that.residentNumber_value}
          let res = await postAction("/app/applicationRecord/fillContractInformation/" + that.uuid, param)
          if(res.success) {
            that.initPdfFile(res.result.pdfUrl);
            that.contractInfo.sourceDocument = res.result.pdfUrl
            that.validata = 'success'
            that.pdfKey = 0
          } else {
            that.$message({showClose: true,message: res.message,type: 'warning'});
          }
        }).catch(() => {
        })
      },
      moment,
      fullScreen(type){
        this.isFull = type
      },
      showHeader(file, fileList){
        this.fileNow = URL.createObjectURL(file.raw);
      },
      phoneInput() {
        let value = this.phone;
        const digits = value.replace(/-/g, '')

        if (digits.length >= 4 && digits.length <= 7) {
          if (!value.startsWith(digits.slice(0, 3) + '-', 0)) {
            value = digits.slice(0, 3) + '-' + digits.slice(3)
          }
        }

        if (digits.length >= 8) {
          const firstPart = digits.slice(0, 3) + '-' + digits.slice(3, 7)
          if (!value.includes(firstPart + '-')) {
            value = firstPart + '-' + digits.slice(7, 11)
          }
        }
        this.phone = value
      },
      residentNumberInput(target) {
        const digits = target.replace(/\D-/g, '');
        const limited = digits.slice(0, 14);
        this.residentNumber = limited;
      },
      async phoneValidate() {
        if (!this.validatePhone) {
          this.errInput = '올바른 휴대폰 번호를 입력해주세요.'
          return
        }
        let result = await postAction("/app/applicationRecord/checkPhoneMatch/" + this.uuid, {phone: this.phone})
        if (result.success) {
          this.initDate()
        } else {
          this.errInput = '카카오 계정의 휴대폰 번호와 일치하지 않습니다.'
        }
      },
      format_phone(localNumber) {
        let format = "XXX-XXXX-XXXX";
        let digits = localNumber.replace(/\D/g, "");
        let formattedNumber = "";
        let digitIndex = 0;
        for (let char of format) {
            if (char === "X" && digitIndex < digits.length) {
                formattedNumber += digits[digitIndex];
                digitIndex++;
            } else {
                formattedNumber += char;
            }
        }
        return formattedNumber;
      },
      async saveSignInfo(){
        this.loading = true
        const params = {
          signingAt:this.signAt,
          signingImage:this.signingImage,
          signingDocument:this.signingDocument
        }
        const res = await putAction('/app/applicationRecord/edit/' + this.uuid,params)
        this.loading = false
        if(res.success){
          Vue.ls.remove('joinDate')
          Vue.ls.remove('leaveDate')
          Vue.ls.remove('salary')
          Vue.ls.remove('money')
          this.$router.replace('/submitResult')
        }else{
          this.$message.error(res.message);
        }
      },
      hasSignature(canvas) {
        const ctx = canvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        const totalPixels = canvas.width * canvas.height;
        let nonTransparentPixels = 0;
        for (let i = 3; i < data.length; i += 4) {
          if (data[i] > 0) {
            nonTransparentPixels++;
          }
        }
        // const areaRatio = nonTransparentPixels / totalPixels;
        if (nonTransparentPixels < 10) {
          return false;
        }
        return true;
      },
      async saveAndUpload() {
        if(this.fileNow == null){
          if(!this.isDraw) {
            this.$message({showClose: true,message: '서명 후 제출하세요.',type: 'warning'});
            return;
          }
          // this.loading = true
          const canvas = this.$refs.canvas;
          if(!this.hasSignature(canvas)) {
            this.$message({showClose: true,message: '올바른 서명을 입력하십시오.',type: 'warning'});
            return;
          }
          const dataURL = canvas.toDataURL('image/png');
          const blob = this.dataURLtoBlob(dataURL);
          this.uploadFile(blob);
        } else {
          this.loading = true
          const canvas = await html2canvas(this.$refs.canvasImage,{scale: 1,backgroundColor: null});
          const dataURL = canvas.toDataURL('image/png');
          const blob = this.dataURLtoBlob(dataURL);
          this.uploadFile(blob);
        }
      },
      async uploadFile(blob) {
        const formData = new FormData();
        formData.append('file', blob, 'image.png');
        const res = await postAction('/app/common/upload',formData)
        this.signingImage = res.result.path
        const params = {
          filePath: this.contractInfo.sourceDocument,
          imagePath:res.result.path,
          applicationId: this.uuid,
          signTime:moment().format('YYYY-MM-DD HH:mm')
        }
        // this.signAt = params.signTime
        const resSubmit = await putAction('/app/applicationRecord/contractAddSign',params)
        if(resSubmit.success){
          this.signingDocument = resSubmit.result.outputPath
          this.signAt = resSubmit.result.signTime
          const res2 = await downFile("/app/common/download/" + resSubmit.result.outputPath)
          let blobResult = new Blob([res2],{type:'application/pdf'})
          this.pdfUrl = URL.createObjectURL(blobResult);
          this.type = 0
          this.pdfKey += 1
          const that = this
          setTimeout(function(){
            that.loading = false
          },2000)
        }else{
          this.$message.error(resSubmit.message);
        }
      },
      dataURLtoBlob(dataURL) {
        const parts = dataURL.split(';base64,');
        const contentType = parts[0].split(':')[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], { type: contentType });
      },
      async initPdfFile(pdfUrl) {
        const res2 = await downFile("/app/common/download/" + pdfUrl)
        let blob = new Blob([res2],{type:'application/pdf'})
        this.pdfUrl = URL.createObjectURL(blob);
      },
      async initDate(){
        this.loading = true
        const res = await getAction('/app/applicationRecord/getInfo/' + this.uuid)
        if(res.success) {
          this.contractInfo = res.result
          if(this.contractInfo.state != null) {
            let pdfUrl = this.contractInfo.signingDocument
            this.initPdfFile(pdfUrl)
            this.validata = 'success'
          } else {
            if(this.contractInfo.address != null) {
              this.address = this.contractInfo.address
              this.companyName = this.contractInfo.companyName
              this.residentNumber_value = this.contractInfo.residentNumber
              this.focusInput();
              this.blurInput();
              this.validata = 'success'
              this.initPdfFile(this.contractInfo.sourceDocument)
            } else {
              this.validata = 'inputFrom'
            }
          }
          const that = this
          this.loading = false
        } else {
          this.$router.push('/home')
        }
      },
      reset_contract_info() {
        this.validata = 'inputFrom'
        this.pdfKey = -1
      },
      signInit(){
        this.type = 1
        const that = this
        setTimeout(function(){
          that.initCanvas();
        },100)
      },
      initCanvas() {
        const canvas = this.$refs.canvas;
        canvas.width = canvas.parentElement.clientWidth;
        canvas.height = canvas.parentElement.clientHeight;
        this.context = canvas.getContext('2d');
        this.context.strokeStyle = '#000000';
        this.context.lineWidth = 4;
      },
      startDrawing(event) {
        event.preventDefault();
        this.isDrawing = true;
        const { x, y } = this.getCoordinates(event);
        this.context.beginPath();
        this.context.moveTo(x, y);
      },
      getCoordinates(e) {
        const canvas = this.$refs.canvas;
        const rect = canvas.getBoundingClientRect();
        let x, y;
        if (e.type.includes('mouse')) {
          x = e.offsetX;
          y = e.offsetY;
        } else {
          x = e.touches[0].clientX - rect.left;
          y = e.touches[0].clientY - rect.top;
        }
        return { x, y };
      },
      clearFunction(){
        this.context.clearRect(0,0,this.$refs.canvas.width,this.$refs.canvas.height)
        this.isDraw = false
      },
      draw(event) {
        this.isDraw = true
        event.preventDefault();
        if (!this.isDrawing) return;
        const { x, y } = this.getCoordinates(event);
        this.context.lineTo(x, y);
        this.context.stroke();
      },
      stopDrawing(e) {
        e.preventDefault();
        this.isDrawing = false;
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  .validata #home{display: flex;flex-direction: column;width: 100%;padding:20px;overflow-y: auto;}
  .validata h1{color:#333333;font-size: 22px;margin:30px 0;}
  .validata p{color: #717B85;}
  .validata .btn{background:#EBECF0;color:#A8A8BC;display: flex;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .validata .btnAct{background:#4873FF !important;color:#ffffff !important;}
  .validata .status{display: flex;align-items: center;padding:40px;width: 100%;}
  .validata .status span{width: 30px;height: 30px;display: flex;flex-shrink: 0;margin:0 10px;justify-content: center;align-items: center;color:#717B85;font-weight: bold;background-color: #EBECF0;border-radius: 50%;}
  .validata .status .act{background-color: #C9D6FF;color: #003DFF;}
  .validata .status p{background-color: #EDEEF2;height: 1px;width: 100%;}
  .validata .errInput >>> .el-input__inner {background-color: #FFF3F3;border-color: #F20000;}
  .validata .error{display: flex;align-items: center;color: #EC0000;font-size: 14px;margin-top: 10px;}
  .validata .error i{margin-right: 5px;font-size: 18px;}
  .validata .xyDiv{background-color: rgba(0, 0, 0, 0.5);position: fixed;left:0;top:0;width: 100vw;height: 100vh;z-index: 10;display: flex;align-items: flex-end;}
  .validata .xyDiv .content{background-color: #ffffff;padding:20px;border-radius: 16px 16px 0 0;display: grid;grid-template-columns: 1fr;gap:30px;width: 100%;}
  .validata .xyDiv .content .header{display: flex;justify-content:space-between;}
  .validata .xyDiv .content .header i{font-size: 20px;}
  .validata .xyDiv .content h1{margin:0;font-size: 20px;}
  .validata .xyDiv .content .list{display: grid;grid-template-columns: 1fr;gap:20px;}
  .validata .xyDiv .content .list .item{color: #717B85;font-size: 14px;display: flex;align-items: center;}
  .validata .xyDiv .content .list .item i{font-size: 24px;margin-right: 6px;}
  .validata .xyDiv .btnConfirm{background:#EBECF0;color:#A8A8BC;display: flex;bottom:20px;justify-content: center;align-items: center;width:100%;height: 52px;border-radius: 26px;font-weight: bold;}

  .contract #home{height: 100vh;display: grid;width: 100%;grid-template-columns: 1fr;gap: 20px;grid-template-rows: auto auto 1fr;}
  .contract h1{color:#333333;font-size: 22px;margin:30px 20px 10px 20px;}
  .contract .btn{background:#EBECF0;color:#A8A8BC;display: flex;justify-content: center;margin:10px 20px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .contract .btnAct{background:#4873FF !important;color:#ffffff !important;}
  .contract .info{display: grid;grid-template-columns: 1fr;gap: 10px;margin:0 20px;}
  .contract .info .item{display: flex;justify-content: space-between;align-items: center;}
  .contract .info .item div{display: flex;flex-direction: column;width: 100%;font-size: 14px;color: #717B85;}
  .contract .info .item span{flex-shrink: 0;color:#717B85;background-color: #EFEFEF;padding:0px 10px;font-size:12px;font-weight:bold;height: 26px;border-radius:8px;display: flex;justify-content: center;align-items: center;}
  .contract .info .item p{font-size: 15px;color: #111111;margin-top: 4px;}
  .contract .info .item p a{color: #006FFF;}
  .contract .info .item .act{background-color:#DDE5FF;color:#1A48DD;}
  .contract .pdfArea{height: 100%;background-color: #EAEFF5;padding:20px 10px 0 10px;display: grid;grid-template-columns: 1fr;grid-template-rows: auto 1fr;}
  .contract .title{margin:0 10px 20px 10px;display: flex;justify-content: space-between;align-items: center;color: #111111;font-weight: bold;}
  .contract .title a{color: #4873FF;font-weight: normal;display: flex;align-items: center;}
  .contract .title a i{margin-right: 6px;}
  .contract .xyDiv{background-color: rgba(0, 0, 0, 0.5);position: fixed;right:0;top:0;width: 100vw;height: 100vh;z-index: 10;display: flex;align-items: flex-end;justify-content: end;}
  .contract .xyDiv .content{background-color: #ffffff;padding:20px;border-radius: 16px 16px 0 0;display: grid;grid-template-columns: 1fr;width: 100%;max-width: 450px;}
  .contract .xyDiv .content .header{display: flex;justify-content:space-between;}
  .contract .xyDiv .content .header i{font-size: 20px;}
  .contract .xyDiv .content h1{margin:0;font-size: 20px;}
  .contract .xyDiv .content .pannel{background-color: #EAEFF5;border-radius: 12px;height: 255px;}
  .contract .xyDiv .title{margin:20px 0;}
  .contract .xyDiv .btnConfirm{background:#EBECF0;color:#A8A8BC;display: flex;bottom:20px;justify-content: center;align-items: center;width:100%;height: 52px;border-radius: 26px;font-weight: bold;}
  .contract .error{display: flex;margin-top:20px;margin-bottom:20px;align-items: center;color: #EC0000;font-size: 14px;justify-content: center;}
  .contract .error i{font-size: 18px;}
  .contract canvas{display: block;width: 100%;height: 100%;}

  .validata {
      position: relative;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch; /* 启用惯性滚动 */
    }


  >>> .vue-office-pdf-wrapper{background: transparent !important;padding:0 0 !important;height: 100% !important;}
</style>
